import styled, { css } from 'styled-components'
import { NectarHeading } from '../../../../helpers/StyledWrappers.styles'

const aspectRatioAsPercentage = (ratio) => {
  const [w, h] = String(ratio).split(':')
  const ratioPercentage = (h / w) * 100
  return `${ratioPercentage.toFixed(2)}%`
}

const setPosition = (position) => css`
  text-align: ${position === 'center' ? 'center' : 'left'};
`

export const StyledContainer = styled.div`
  margin-bottom: ${(props) => `${props.theme.size.spacing.lg}`};
`

export const StyledHeading = styled.h1`
  ${(props) => setPosition(props.alignment)}
  ${NectarHeading}
  && {
    /* We need increased specificity here to override the bolt typography styles */
    margin-bottom: ${(props) => `${props.theme.size.spacing.lg}`};
  }
`

export const StyledMediaWrapper = styled.div`
  display: block;
  position: relative;
  margin-bottom: ${(props) => `${props.theme.size.spacing.lg}`};

  &::after {
    display: block;
    content: '';

    /* Use padding-bottom to fix the aspect-ratio on images */
    @media only screen and (max-width: ${(props) => props.breakpoint}) {
      padding-bottom: ${aspectRatioAsPercentage('4:3')};
    }
    ${(props) => {
      switch (props.mediaRatio) {
        case 'tall':
          return css`
            padding-bottom: ${aspectRatioAsPercentage('21:9')};
          `
        case 'short':
        default:
          return css`
            padding-bottom: ${aspectRatioAsPercentage('10:3')};
          `
      }
    }}
  }

  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

export const StyledCopy = styled.p`
  ${(props) => setPosition(props.alignment)}

  && {
    /* We need increased specificity here to override the bolt typography styles */
    margin-bottom: ${(props) => `${props.theme.size.spacing.lg}`};
  }
`
